import { PastYearsSelectHeader } from "../components/elements/DateSelectHeader";
import { CommissionRateFormStages } from "./commissionRate";
import lookups from "./lookups";

export const CommissionRatesFormStages = [
  {
    title: "Commission Rates",
    sections: [
      {
        name: "",
        table: {
          allowAdd: true,
          allowEdit: true,
          allowStatusEdit: true,
          fields: [
            {
              name: "g4b_commissiongroupid",
              className: "col-short-name",
            },
            {
              name: "g4b_commissioncategoryid",
              className: "col-name",
            },
            { name: "g4b_rate", className: "col-number" },
            { name: "g4b_giftaidrate", className: "col-number" },
            {
              name: "createdon",
              className: "col-date",
              type: "datetime",
            },
            {
              name: "modifiedon",
              className: "col-date",
              type: "datetime",
            },
          ],
          filterByStatus: true,
          filters: [
            {
              textFieldsSearch: ["Name"],
              type: "text",
            },
            {
              name: "g4b_commissiongroupid",
              type: "select",
            },
            {
              name: "g4b_commissioncategoryid",
              type: "select",
            },
            {
              name: "createdon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
            {
              name: "modifiedon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
          ],
          linkForNewRecord: "/commission-rate",
          lookup: lookups.g4b_commissionrate.all,
          subFormStages: CommissionRateFormStages,
          useAlphabetPagination: true,
          useSubForm: false,
        },
      },
    ],
  },
];
